import 'whatwg-fetch';
import cloneDeep from 'lodash.clonedeep';

import * as tokenHelper from '../../../helpers/TokenHelper';
import { rateLimitedfetch } from '../../requestLimiter';

import { getObject, validateResponse } from './';

const productName = 'videoscribe-cloud';

class Projects {
  constructor(services) {
    this._services = services;

    this.updateProject = this.updateProject.bind(this);
    this.createProject = this.createProject.bind(this);
  }

  getProjectList(queryParams = '') {
    const uid = tokenHelper.getUID();
    const url = `${this._services._baseUrl}user/${uid}/projects/${productName}${queryParams}`;
    const options = this._services.getOptions();

    return rateLimitedfetch(url, options)
      .then(r => validateResponse(r, `Error fetching your projects.`))
      .then(getObject)
      .then(response => {
        return response;
      });
  }

  getProject = scribeId => {
    const url = `${this._services._baseUrl}project-data/${scribeId}`;
    const options = this._services.getOptions('GET');

    return rateLimitedfetch(url, options)
      .then(r => validateResponse(r, `Error fetching scribe ${scribeId}.`))
      .then(getObject);
  };

  createProject(project) {
    const url = `${this._services._baseUrl}project-data`;
    // const clone = cloneDeep(project);
    const options = this._services.getOptions(
      'POST',
      JSON.stringify({
        title: project.title,
        appName: productName,
        projectModel: project
      })
    );

    return rateLimitedfetch(url, options)
      .then(r => validateResponse(r, `Error creating scribe.`))
      .then(getObject)
      .then(response => {
        const data = response;
        const id = data.projectDataId;

        project.id = id;

        return project;
      });
  }

  deleteProject(project) {
    const url = `${this._services._baseUrl}project-data/${project.id}`;
    const options = this._services.getOptions('DELETE');

    return rateLimitedfetch(url, options).then(r => validateResponse(r, `Error deleting your scribe.`));
  }

  updateProject(project) {
    const url = `${this._services._baseUrl}project-data/${project.id}`;
    const clone = cloneDeep(project);

    delete clone.updatedOn;
    delete clone.viewOnly;

    const data = {
      title: clone.title,
      projectModel: clone
    };
    const options = this._services.getOptions('PUT', JSON.stringify(data));

    return rateLimitedfetch(url, options)
      .then(r => validateResponse(r, `Error updating your scribe.`))
      .then(getObject);
  }
}

export default Projects;
